import { useEffect } from 'react';

import { startInactiveSpan } from '@sentry/react';
import type { Span } from '@sentry/core';

/**
 * Times a route element's load as a child of the active navigation span, which
 * keeps that idle span open until the element renders: a lazy chunk or the
 * catalog download produces no request span of its own to do so.
 */
const useRouteLoadingSpan = () => {
  useEffect(() => {
    let span: Span | undefined;
    let loaded = false;
    // The navigation span starts in an ancestor's effect, which runs after this one in the same commit.
    queueMicrotask(() => {
      if (!loaded) span = startInactiveSpan({ name: 'route element load', op: 'ui.react.suspense', onlyIfParent: true });
    });
    return () => {
      loaded = true;
      span?.end();
    };
  }, []);
};

export default useRouteLoadingSpan;
